<template>
    <div class="sub-visual">
        <div class="sub-visual-tit white--text" v-if="tit">
            <v-container>
                <h2 class="tit tit--lg">{{ tit }}</h2>
                <p class="page-text page-text--lg mt-12 mt-lg-20" v-if="sc">{{ sc }}</p>
            </v-container>
        </div>
        <div class="sub-visual-bg" :style="'background-image:url(' + bg + ');'"></div>
    </div>
</template>

<script>
export default {
    props: {
        tit: { type: String, default: "" },
        sc: { type: String, default: "" },
        bg: { type: String, default: "" },
    },
    components: {},
    data: () => {
        return {};
    },
    created() {},
    // mounted() {
    // 	this.init();
    // },
    // methods : {
    //     init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: true,
    //                 offset: 240,
    //                 duration: 500,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
    // 	}
    // },
};
</script>

<style scoped>
.sub-visual {
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: relative;
}
.sub-visual-tit {
    position: relative;
    z-index: 1;
}
.sub-visual-tit h2 {
    color: #fff;
}
.sub-visual-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 0;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .sub-visual {
        height: 260px;
    }
}
@media (min-width: 1024px) {
    .sub-visual {
        height: 300px;
    }
}
@media (min-width: 1200px) {
}
</style>
